module.exports = __webpack_public_path__ + "img/african.206953a6.jpeg";